import { render, staticRenderFns } from "./classifiersTable.vue?vue&type=template&id=1f35a405&scoped=true"
import script from "./classifiersTable.vue?vue&type=script&lang=js"
export * from "./classifiersTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f35a405",
  null
  
)

export default component.exports